module.exports = __webpack_public_path__ + "static/media/main idea.d6c63b9d.mp3";